export class EnumApiUsersvr {
    constructor() {
        /**
         * @dec 获取省份
         * @method get
         */
        this.usersvr_get_provinces = {
            url: '/api/gateway/pcsd-bp-customer-usersvr/v1/area/provinces',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec 获取城市
         * @method get
         */
        this.usersvr_get_citys = {
            url: '/api/gateway/pcsd-bp-customer-usersvr/v1/area/cities/{provideCode}',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec 获取区县、街道
         * @method get
         */
        this.usersvr_get_district = {
            url: '/api/gateway/pcsd-bp-customer-usersvr/v1/area/district/{cityCode}',
            method: 'get',
            loading: true,
            awaitAuthenticated: false,
        };
        /**
         * @dec 获取市场活动,资料，新闻，等
         */
        this.usersvr_bizNews = {
            // url: '/api/gateway/pcsd-bp-customer-usersvr/v2/bizNews',
            url: '/api/gateway/pcsd-bp-customer-usersvr/v1/WorkbenchCockpit/latestNewsInfo',
            // awaitAuthenticated:false,
        };
        /**
         * @dec 获取市场活动,资料，新闻，详情
         */
        this.usersvr_bizNews_details = {
            url: '/api/gateway/pcsd-bp-customer-usersvr/v1/bizNews/{id}',
            // awaitAuthenticated:false,
        };
        /**
         * @dec 根据登陆的地址获取sales的信息
         */
        this.usersvr_salesInfo = {
            url: '/api/gateway/pcsd-bp-customer-usersvr/v2/sales/findByCity',
        };
    }
}
